export default __webpack_public_path__ + "static/media/Contact (1600).642a7b53.png";